import { DashboardProvider } from 'contexts/dashboard.context';
import React from 'react';
import DashboardContent from './content';

const DashboardLayout = () => {
  return (
    <DashboardProvider>
      <DashboardContent />
    </DashboardProvider>
  );
};

export default DashboardLayout;
